import { VIRTUAL_SCROLL_STRATEGY } from "@angular/cdk/scrolling";
import { AfterViewChecked, Component, Inject, Renderer2 } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { CustomVirtualScroll } from "@classes/CustomVritualScoll";
import { MPlay } from "@models/api-models/plays-api.models";
import { ResultDraw } from '@models/resultDraw.model';

@Component({
    selector: 'app-bottomSheetPremiosParticipacion',
    templateUrl: './bottomSheetPremiosParticipacion.component.html',
    styleUrls: ['./bottomSheetPremiosParticipacion.component.scss'],
    providers: [{ provide: VIRTUAL_SCROLL_STRATEGY, useClass: CustomVirtualScroll }],
    standalone: false
})
export class bottomSheetPremiosParticipacionComponent implements AfterViewChecked
{
    jugada: any;
    constructor(private bottomSheetJugadaRegalada: MatBottomSheetRef<bottomSheetPremiosParticipacionComponent>,
                @Inject(MAT_BOTTOM_SHEET_DATA) public data: {jugada},
                private renderer: Renderer2
    ){

        this.jugada = data.jugada;
    }

    ngAfterViewChecked()
    {
        this.setRandomColor();
    }

    dimiss()
    {
        this.bottomSheetJugadaRegalada.dismiss();
    }

    getFirstLetter(letra: string)
    {
        return letra.toLocaleUpperCase()[0];
    }

    setRandomColor() 
    {
        document.querySelectorAll("div[class='letter']").forEach(x=>{
            this.renderer.setStyle(x,"background-color",this.generateColors());
        })
    }

    private generateColors()
    {
        let letters = '0123456789ABCDEF';
        let color = '#';

        for (var i = 0; i < 6; i++){
            color += letters[Math.floor(Math.random() * 16)];
        }

        return color;
    }
}